
<div class="w-100">
    <!-- no recipients availible -->
    <div
        v-if  = "!recipients"
        class = "lm-border pa-3 error white--text"
    >
        <v-icon
            size="22"
            color="white"
        >
            mdi-alert
        </v-icon>
        <span
            class="recipients-missing">Keine {{ type }}
        </span>
    </div>
    <!-- no recipients availible -->

    <!-- recipients selection -->
    <v-autocomplete
        v-if              = "recipients"
        v-model           = "selected"
        :items            = "recipients"
        item-value        = "id"
        item-text         = "name"
        :label            = "type"
        @change           = "onSelected"
        autocomplete      = "off"
        autocorrect       = "off"
        autocapitalize    = "off"
        spellcheck        = "false"
        :background-color = "collective ? 'field-group-background-blue' : ''"
        auto-select-first
        hide-details
        return-object
        clearable
    >
        <template v-slot:item="data">
            <div class="mt-2 mb-2" style="width: 600px">
                <div class="v-flex">
                    <div style="padding-top: 1px;">{{ data.item.name }}</div>
                </div>
                <div class="v-flex">
                    <div style="font-size: 13px">{{ data.item.nameAdd }}</div>
                </div>
                <div style="font-size: 13px">
                    {{ data.item.street }} {{ data.item.zip }}  {{ data.item.city }}
                </div>
            </div>
        </template>
    </v-autocomplete>
    <!-- recipients selection -->

    <!-- info of selected recipient -->
    <div
        :style = "collective ? 'background-color: aliceblue' : ''"
        class  = "pl-1 pb-2"
    >
        <div class="pt-2"></div>
        <div style="font-size: 13px"  v-if="selected != null">
            {{ selected.nameAdd }}
        </div>
        <div style="font-size: 13px"  v-if="selected != null">
            {{ selected.street }}
        </div>
        <div style="font-size: 13px"  v-if="selected != null">
            {{ selected.zip }}  {{ selected.city }}
        </div>
    </div>
    <!-- info of selected recipient -->
</div>

